import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const faqs = [
  { q: "How do I get an expedited passport in Jackson, Wyoming?", a: "Jackson residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Salt Lake City, 3+ hours away." },
  { q: "Where is the nearest passport agency to Jackson Hole?", a: "The Denver Regional Passport Agency (3151 S Vaughn Way, Suite 600, Aurora, CO 80014) is 450+ miles southeast of Jackson via US-26/I-25. Fast Passport Center eliminates that trip for most applicants." },
];

export default function JacksonWYPage() {
  return (
    <div className="min-h-screen bg-white">
      <CitySEOHead
        city="Jackson"
        state="Wyoming"
        stateAbbr="WY"
        route="/jackson-wy"
        title="Emergency Passport Jackson, WY — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Jackson, Wyoming and Jackson Hole. Serving Teton County. As fast as 24 hours — no Salt Lake City agency trip needed."
        geoPlacename="Jackson, Wyoming"
        geoPosition="43.4799;-110.7624"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Wyoming"
        statePageRoute="/states/wyoming"
      />
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
    </div>
  );
}